import { render, staticRenderFns } from "./CertificationTable.vue?vue&type=template&id=5d17a53a&scoped=true"
import script from "./CertificationTable.vue?vue&type=script&lang=js"
export * from "./CertificationTable.vue?vue&type=script&lang=js"
import style0 from "./CertificationTable.vue?vue&type=style&index=0&id=5d17a53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d17a53a",
  null
  
)

export default component.exports